import { ReactNodeViewRenderer as g } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { IMAGE_MOBILE_FULL_WIDTH_STYLES as l } from "../../constants/default-styles.mjs";
import { ImageNameEnum as p, ImageModeEnum as L } from "./image-enum.mjs";
import { convertStyleObjectToCss as A } from "../../utils/style-helpers.mjs";
import { CustomImage as d } from "./custom-image.mjs";
import { Image as M } from "./image.mjs";
import { getContainerWidthFromElement as T } from "./utils/get-container-width-from-element.mjs";
import { getImageAttrs as _ } from "./utils/get-image-attrs.mjs";
import { getImageWithLinkHtml as u } from "./utils/get-image-with-link-html.mjs";
import { MOBILE_FULL_WIDTH_DATA_ATTRIBUTE as c, MOBILE_FULL_WIDTH_CLASSNAME as W } from "./constants/index.mjs";
import { mergeAttributes as b } from "../../node_modules/@tiptap/core/dist/index.mjs";
const R = M.configure({ inline: !0 }).extend({
  name: p.Inline,
  inline: !0,
  addNodeView() {
    return g(d);
  },
  parseHTML() {
    return [
      {
        tag: "img",
        getAttrs: (t) => {
          const e = t.closest("a"), i = e == null ? void 0 : e.getAttribute("href"), r = _(t), o = T(t), s = t.getAttribute(c) === "true" || !!t.closest(`.${W}`);
          return {
            imageMode: L.Inline,
            ...r,
            href: i,
            containerWidth: o,
            isMobileFullWidth: s
          };
        }
      }
    ];
  },
  renderHTML({
    HTMLAttributes: { href: t, alt: e, title: i, width: r, height: o, containerWidth: m, src: s, isMobileFullWidth: I }
  }) {
    const n = {};
    r && o && (n.aspectRatio = `${r}/${o}`), m !== "auto" && (n.width = m);
    const a = b({
      src: s,
      alt: e,
      title: i,
      width: r,
      style: A(n)
    });
    if (I) {
      const f = u(
        {
          ...a,
          [c]: "true"
        },
        { href: t }
      );
      return [
        "span",
        ["head", {}, ["style", { type: "text/css" }, l]],
        f
      ];
    }
    return u(a, { href: t });
  }
});
export {
  R as InlineImage
};
